
import React from "react";
import { Separator } from "@/components/ui/separator";
import { Span } from "@/components/ui/typography";

type AuthDividerProps = {
  text?: string;
};

const AuthDivider = ({ text = "or continue with" }: AuthDividerProps) => {
  return (
    <div className="relative w-full my-2">
      <Separator className="absolute inset-0 m-auto bg-mono-slateGray/20" />
      <div className="relative flex justify-center">
        <Span size="small" variant="muted" className="bg-mono-eerieBlack px-2">{text}</Span>
      </div>
    </div>
  );
};

export default AuthDivider;
